import { useIsPC } from '~/lib/ua'
import { Links } from './Links'
import { Main } from './Main'
import { Section, TitleLink } from './Section'
import type { Genre } from './data/type'

export function Genre({ genre }: { genre: Genre }) {
  const isPc = useIsPC()
  const title =
    import.meta.env.VITE_MODE === 'ppg' ? (
      '料理ジャンルから探す'
    ) : (
      <TitleLink title="料理ジャンルから探す" href="/t-genre/" />
    )
  if (isPc) {
    return (
      <Section title={title} subContent={<Links items={genre.sub} />}>
        <Main type="genres" items={genre.main} />
      </Section>
    )
  }
  return (
    <Section title={title} hiddenContent={<Links items={genre.sub} />}>
      <Main type="genres" items={genre.main} />
    </Section>
  )
}
